var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18182 0L6.45455 5.27273C6.3661 5.54656 6.21392 5.79549 6.01052 5.99905C5.80712 6.20261 5.55831 6.35498 5.28454 6.44364L0 8.18182L5.27273 9.90909C5.54656 9.99754 5.79549 10.1497 5.99905 10.3531C6.20261 10.5565 6.35498 10.8053 6.44364 11.0791L8.18182 16.3636L9.90909 11.0909C9.99754 10.8171 10.1497 10.5681 10.3531 10.3646C10.5565 10.161 10.8053 10.0087 11.0791 9.92L16.3636 8.18182L11.0909 6.45455C10.8171 6.3661 10.5681 6.21392 10.3646 6.01052C10.161 5.80712 10.0087 5.55831 9.92 5.28454L8.18182 0Z",
    fill: "url(#paint0_linear_16065_204469)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4517 10.9102L14.4921 13.8394C14.443 13.9916 14.3584 14.1299 14.2454 14.243C14.1324 14.356 13.9942 14.4407 13.8421 14.49L10.9062 15.4556L13.8355 16.4152C13.9877 16.4643 14.126 16.5489 14.2391 16.6619C14.3521 16.7749 14.4368 16.9131 14.486 17.0652L15.4517 20.0011L16.4113 17.0718C16.4604 16.9196 16.545 16.7813 16.658 16.6683C16.771 16.5552 16.9092 16.4705 17.0613 16.4213L19.9972 15.4556L17.0679 14.496C16.9157 14.4469 16.7774 14.3623 16.6644 14.2493C16.5513 14.1363 16.4666 13.9981 16.4174 13.846L15.4517 10.9102Z",
    fill: "url(#paint1_linear_16065_204469)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16065_204469",
    x1: 5.45455,
    y1: 4.09091,
    x2: 15.5968,
    y2: 4.71903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812131,
    stopColor: "#6C94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961538,
    stopColor: "#A497FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16065_204469",
    x1: 11.4983,
    y1: 8.68338,
    x2: 20.4509,
    y2: 9.81848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6F4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812131,
    stopColor: "#6C94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961538,
    stopColor: "#A497FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai_icon.9c157b8c94690c9b5937bf6446fbb26a.svg";
export { ForwardRef as ReactComponent };